import React, { Component } from 'react';

import { RadioButtonGroup, SelectField } from 'redux-form-material-ui';
import { Field, reduxForm } from 'redux-form';
import validate from './validate';

import RadioButton from 'material-ui/RadioButton';
import MenuItem from 'material-ui/MenuItem';

import { colors } from 'helpers/ColorHelper';

const renderError = ({ meta: { touched, error } }) =>
  touched && error ? (
    <p style={{ color: colors.RED, fontSize: '11px', textAlign: 'center' }}>{error}</p>
  ) : (
    false
  );

class PropertyType extends Component {
  render() {
    const { handleSubmit } = this.props;

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <div className="row" style={{ marginBottom: '70px' }}>
            <h3 style={{ textAlign: 'center', margin: '25px 0px 5px 0px' }}>
              What kind of property are you adding?
            </h3>
            <p style={{ textAlign: 'center', marginBottom: '0px' }}>
              Please choose the type of property you are adding. If you don&#39;t see your property
              type, contact us :)
            </p>
            <Field
              name="property_type"
              component={SelectField}
              floatingLabelText="Property Type"
              style={{
                marginTop: '-15px',
                fontSize: '14px',
                textAlign: 'left',
                width: '100%',
              }}
            >
              <MenuItem value={'apartment'} primaryText={'Apartment'} />
              <MenuItem value={'commercial'} primaryText={'Commercial'} />
              <MenuItem value={'condo'} primaryText={'Condo'} />
              <MenuItem value={'industrial'} primaryText={'Industrial'} />
              <MenuItem value={'office'} primaryText={'Office'} />
              <MenuItem value={'single_family'} primaryText={'Single Family'} />
              <MenuItem value={'student'} primaryText={'Student Housing'} />
              <MenuItem value={'parking_lot'} primaryText={'Parking Lot'} />
            </Field>

            <h4
              style={{
                textAlign: 'center',
                marginBottom: '5px',
                marginTop: '35px',
              }}
            >
              Is this a single unit?
            </h4>
            <p style={{ textAlign: 'center', marginBottom: '15px' }}>
              If you only require one lease to be signed for this property, select yes.
            </p>
            <Field
              name="is_single_unit"
              component={RadioButtonGroup}
              style={{ width: '187px', margin: 'auto' }}
            >
              <RadioButton
                value="true"
                label="Yes"
                style={{ width: '102px', display: 'inline-flex' }}
              />
              <RadioButton
                value="false"
                label="No"
                style={{
                  width: '70px',
                  display: 'inline-flex',
                  float: 'right',
                }}
              />
            </Field>
            <Field name="is_single_unit" component={renderError} />
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'add_property',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(PropertyType);
